import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { useIsDisabledCalculator } from '@src/reducers/metadata';
import { useHasUtmLabel } from '@src/reducers/route';
import { isInostrancamPage, isMainPage } from '@src/utils/routing';

import { isShowCalculatorByQuery } from './isShowCalculatorByQuery';

export const useIsShowFullDealEntrypoint = () => {
  const isDisabledCalculatorServer = useIsDisabledCalculator();

  const hasUtmLabel = useHasUtmLabel();
  const { asPath, query } = useRouter();
  const isInostrancam = isInostrancamPage(asPath);
  const isMain = isMainPage(asPath, query);
  const isShowCalculator = isShowCalculatorByQuery(query);

  return useMemo(() => {
    if (isInostrancam) {
      return false;
    }

    if (isDisabledCalculatorServer) {
      return false;
    }
    if (isShowCalculator === true) {
      return true;
    }

    if (isShowCalculator === false || (isMain && hasUtmLabel)) {
      return false;
    }

    if (hasUtmLabel) {
      return true;
    }

    return !hasUtmLabel;
  }, [isInostrancam, isDisabledCalculatorServer, isShowCalculator, isMain, hasUtmLabel]);
};
